app.service('caseManagementService', function ($http) {

  // Routes | Certified Values |-----------------------------------------
  
  this.saveDocketRecord = function (obj) {
    return $http.post(`/caseManagement/saveDocketRecord`, obj)
      .then(function (response) {
        return response
      })  
  }
  
  this.loadDocket = function (obj) {
    return $http.post(`/caseManagement/loadDocket`, obj)
      .then(function (response) {
        return response
      })
  }

  this.loadCaseData = function (obj) {
    return $http.post(`/caseManagement/loadCaseData`, obj)
      .then(function (response) {
        return response
      })
  }

  this.loadCaseDataCounties = function (obj) {
    return $http.post(`/caseManagement/loadCaseDataCounties`, obj)
      .then(function (response) {
        return response
      })
  }

  this.updateCaseAgent = function (obj) {
    return $http.post(`/caseManagement/updateCaseAgent`, obj)
      .then(function (response) {
        return response
      })
  }

  this.bulkUpdateCaseAgent = function (obj) {
    return $http.post(`/caseManagement/bulkUpdateCaseAgent`, obj)
      .then(function (response) {
        return response
      })
  }

  this.updateHearingDate = function (obj) {
    return $http.post(`/caseManagement/updateHearingDate`, obj)
      .then(function (response) {
        return response
      })
  }

  this.updateNotes = function (obj) {
    return $http.post(`/caseManagement/updateNotes`, obj)
      .then(function (response) {
        return response
      })
  }

  this.matchAppealsByCadAccounts = function (obj) {
    return $http.post(`/caseManagement/matchAppealsByCadAccounts`, obj)
      .then(function (response) {
        return response
      })
  }

  this.addCaseManagementRecords = function (obj) {
    return $http.post(`/caseManagement/addCaseManagementRecords`, obj)
      .then(function (response) {
        return response
      })
  }

  //-------------------------------------------------

})